import { render, staticRenderFns } from "./IconSvgTarget.vue?vue&type=template&id=88dcacfa&scoped=true&"
import script from "./IconSvgTarget.vue?vue&type=script&lang=js&"
export * from "./IconSvgTarget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88dcacfa",
  null
  
)

export default component.exports